const routes = {
  createSalePerson: 'salesperson',
  getSalePersons: 'salesperson',
  getSalePersonById: 'salesperson/',
  updateSalePerson: 'salesperson/',
  deleteSalePerson: 'salesperson/',
};

export default routes